import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import GConf from '../../../AssetsM/generalConf';

function CommandeTemp(props) {
    let {CID} = useParams()
    let [articleL, setArticleL] = useState([])
    let [commandeData, setCommandeD] = useState([])
    let [loading, setLoading] = useState(true)

    useEffect(() => {
        axios.post(`${GConf.ApiLink}/commande/info`, {
            tag: GConf.SystemTag,
            CID: CID
          })
          .then(function (response) {
                 
                setCommandeD(response.data[0])
                setLoading(false)
                if(response.data[0].Articles != '' ){ setArticleL(JSON.parse(response.data[0].Articles)) }
    
          })
    }, [])



    return ( <>
            {loading ? <></> : 
            <div className="container-fluid p-5">
                <h1 className='text-center'>عقد كراء قاعة أفراح متنقلة </h1> 
                <br />
                <br />
                <br />
                <h3 dir='rtl'>سوغ السيد : أيمن ين المولدي الصغيري صاحب بطاقة تعريف وطنية عدد 04553304 الصادرة في توني في 26-10-2005 و القاطن بحي الجامع يسيدي بورويس </h3>
                <h3  dir='rtl'>من جهة </h3>
                <h3  dir='rtl'> و السيد {commandeData.Client_Name} صاحب بطاقة تعريف وطنية عدد {commandeData.Client_CIN}  الصادرة بتونس ........................... في ............................ و القاطن  بـ ..........................  </h3>
                <h3  dir='rtl'> من جهة أخري  </h3>
                <h3  dir='rtl'> قاعة أفراح متنقلة بجميع لوازمها بمبلغ جملي متفق عليه قدرة {commandeData.Client_Prix}  د يقع تسديده يوم الحفل في الأجل المتفق عليه المحدد يوم {new Date(commandeData.Date_Volu).toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' )} يتعهد المتسوغ بدفع تسبقة كعربون قدرها {commandeData.Client_PrTranche}  د </h3>
                <h3 className='mb-0' dir='rtl'>يتسلم المتسوغ  :   </h3>
                <h3 className='mt-2' dir='rtl'> 
                    {articleL.length == 0 ? 
                    <ul>
                        <li>  قاعة الافراح بعد معاينتها و لجميع مستلزماتها ليكون مسؤولا علي أي تكسير أو تخريب داخلها   </li> 
                        <li>عدد ................. كرسي </li> 
                        <li>عدد ................. طاولة </li> 
                        <li>عدد ................. مغارف </li> 
                        <li>عدد ................. صحن </li> 
                        <li>عدد ................. منصة فرقة </li> 
                        <li>عدد ................. منصة العروسة </li> 
                        <li>عدد ................. طاولة حنة  </li> 
                        <li>عدد ................. سياج حارجي </li> 
                        <li>عدد ................. سياج داخلي </li> 
                        <li>عدد ................. خيمة </li> 
                        <li>عدد ................. ثلاجة </li> 
                        <li>عدد ................. قلعة </li> 
                        <li>عدد ................. الأطار المفروشة </li> 
                        <li>عدد ................. معدات الإنارة </li> 
                        <li> معلوم النقلة </li> 
                    </ul>
                    :
                        <ul className='ps-4'>
                            <li>  قاعة الافراح بعد معاينتها و لجميع مستلزماتها ليكون مسؤولا علي أي تكسير أو تخريب داخلها   </li> 
                            {articleL.map((data,index) => <li className='ms-5'>{data.qte} x {data.Name}</li>)}
                        </ul>
                    }
                </h3>
                <h3  dir='rtl'> حدوث أي شغب أو تكسير في محتوايتها يتحمل المتسوغ جميع المصاريف المنجرة عن التخريب أو التكسير أو دفع ثمن ما أتلف علي الفور  </h3>
                <h3  dir='rtl'> في صورة ما إذا وقع إلغاء الحفل يجب علي المتسوغ دفع المبلغ المتفق عليه دون أي تردد أو إحداث مشكل  </h3>
                <h3  dir='rtl'> صاحب القاعة لا يتحمل أي مسؤولية تخص : الفرقة الموسيقية / الوجبات الغذائية / الصور الفوتوغرافية / و ماله صلة بذلك </h3>
                <h3  dir='rtl'> إتفق الطرفات بما جاء في هذا العقد و صادقا عليه بعد قرائته  </h3>
               <br />
                <div className="row">
                    <div className="col-6 text-center">
                        إمضاء المتسوغ
                    </div>
                    <div className="col-6 text-center">
                        إمضاء صاحب القاعة 
                    </div>
                </div>
            </div>
            }
    </> );
}

export default CommandeTemp;